import SectionHeading from "@/components/base/SectionHeading";
import Tag from "@/components/base/Tag";
import Reveal from "@/components/base/Reveal";
import { influencers } from "@/mocks/homeData";

export default function InfluencerDirectory() {
  return (
    <section id="directory" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          eyebrow="达人名录"
          eyebrowIcon="ri-contacts-book-2-line"
          title="被记录过的达人，按事件数排"
          desc="每个词条下面挂着已归档的事件数量与最近动态。想知道某个人是不是「老熟人」，看这里最直接。"
          action={
            <a
              href="#community"
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-add-line"></i>
              </span>
              提名补录
            </a>
          }
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {influencers.map((person, index) => (
            <Reveal key={person.id} delay={index * 50}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300">
                <div className="flex items-center gap-3">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-600">
                    <i className={person.icon}></i>
                  </span>
                  <div className="min-w-0">
                    <h3 className="truncate font-heading text-base font-bold text-foreground-950">{person.name}</h3>
                    <p className="truncate text-[11px] text-secondary-600">{person.handle}</p>
                  </div>
                </div>

                <div className="mt-4 flex flex-wrap items-center gap-2">
                  <Tag variant="secondary">{person.platform}</Tag>
                  <Tag variant="accent">{person.tag}</Tag>
                </div>

                <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-foreground-600">{person.note}</p>

                <div className="mt-4 grid grid-cols-2 gap-3 border-t border-background-200 pt-4">
                  <div>
                    <p className="font-mono text-base font-bold text-foreground-950">{person.cases}</p>
                    <p className="mt-0.5 text-[11px] text-secondary-600">已归档事件</p>
                  </div>
                  <div>
                    <p className="font-mono text-base font-bold text-foreground-950">{person.followers}</p>
                    <p className="mt-0.5 text-[11px] text-secondary-600">粉丝量级</p>
                  </div>
                </div>

                <a
                  href="#directory"
                  className="mt-4 inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-background-100 px-4 py-2 text-xs font-medium text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  查看全部记录
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}